/**
 * Configuración de Navegación de la Aplicación
 * 
 * Este archivo centraliza toda la estructura del menú sidebar,
 * facilitando el mantenimiento y la adición de nuevas secciones.
 */
import {
  Home,
  FileText,
  Package,
  Ship,
  Bell,
  FileImage,
  Settings,
  PieChart,
  AlertTriangle,
  Download,
  Calculator,
  GitCompare,
  History,
  Zap,
  Users,
  MapPin,
  Languages,
  Coins,
  Building,
  Shield,
  Activity,
  Receipt,
  BarChart3,
  LifeBuoy,
  Truck,
  Upload,
  Database,
  TestTube,
  Lock,
  KeyRound,
  Gauge,
  Link2,
} from "lucide-react"
export interface NavItem {
  title: string
  href: string
  icon: React.ComponentType<{ className?: string }>
  badge?: string | number // Opcional: para mostrar badges/contadores
  description?: string // Opcional: para tooltips
  disabled?: boolean // Opcional: para deshabilitar el item
  comingSoon?: boolean // Opcional: para marcar como "próximamente"
}
export interface NavGroup {
  title: string
  icon: React.ComponentType<{ className?: string }>
  items: NavItem[]
  collapsed?: boolean // Opcional: estado inicial del grupo
}
/**
 * Items de navegación de nivel superior (fuera de grupos)
 */
export const topLevelItems: NavItem[] = [
  { 
    title: "Contratos", 
    href: "/contratos", 
    icon: FileText,
    description: "Gestión de contratos"
  },
  { 
    title: "Tarifas", 
    href: "/tarifas", 
    icon: Calculator,
    description: "Tarifas"
  },
  { 
    title: "Reservas", 
    href: "/bookings", 
    icon: Ship,
    description: "Gestión de reservas"
  },
  {
    title: "Salud Conciliacion",
    href: "/bookings/reconciliation-health",
    icon: Gauge,
    description: "Diagnostico REPO_DOC por estado de conciliacion"
  },
  {
    title: "Salud Asignación Contratos",
    href: "/bookings/contract-assignment-health",
    icon: Link2,
    description: "Diagnóstico de asignación de equipos a líneas de contrato"
  },
  { 
    title: "Monitor", 
    href: "/monitor", 
    icon: Activity,
    description: "Monitor de operaciones (próximamente)",
    disabled: true,
    comingSoon: true,
    badge: "Pronto"
  },
  { 
    title: "Facturas de Proveedores", 
    href: "/finanzas/facturas", 
    icon: FileText,
    description: "Facturas de proveedores"
  },
  { 
    title: "Facturas Internas", 
    href: "/finanzas/facturas-internas", 
    icon: Receipt,
    description: "Facturas internas"
  },
  { 
    title: "Importaciones", 
    href: "/importaciones", 
    icon: Upload,
    description: "Importar contratos y facturas desde Excel"
  },
  { 
    title: "Análisis de bolsa", 
    href: "/finanzas/analisis-bolsa", 
    icon: BarChart3,
    description: "Análisis financiero",
    disabled: true,
    comingSoon: true,
    badge: "Pronto"
  },
  { 
    title: "Maestros", 
    href: "/maestros", 
    icon: Database,
    description: "Gestión de maestros y nomencladores"
  },
  { 
    title: "Notificaciones", 
    href: "/notificaciones", 
    icon: Bell,
    description: "Centro de notificaciones",
    disabled: true,
    comingSoon: true,
    badge: "Pronto"
  },
]
/**
 * Grupos de navegación (secciones colapsables)
 */
export const navigationGroups: NavGroup[] = [
  {
    title: "Seguridad",
    icon: Lock,
    items: [
      {
        title: "Roles",
        href: "/configuracion/roles",
        icon: Shield,
        description: "Plantillas de permisos por rol"
      },
      {
        title: "Permisos",
        href: "/configuracion/permisos",
        icon: KeyRound,
        description: "Permisos individuales por usuario"
      },
    ],
  },
{
    title: "Configuración",
    icon: Settings,
    items: [
      {
        title: "Usuarios",
        href: "/configuracion/usuarios",
        icon: Users,
        description: "Administración de usuarios"
      },
    ],
  },
]
/**
 * Helper para obtener el item de navegación según la ruta actual
 */
export function getNavItemByPath(pathname: string): NavItem | undefined {
  // Buscar en items de nivel superior
  const topLevel = topLevelItems.find(item => item.href === pathname)
  if (topLevel) return topLevel
  // Buscar en grupos
  for (const group of navigationGroups) {
    const groupItem = group.items.find(item => item.href === pathname)
    if (groupItem) return groupItem
  }
  return undefined
}
/**
 * Helper para verificar si una ruta está activa
 */
export function isNavItemActive(itemHref: string, currentPath: string): boolean {
  // Coincidencia exacta
  if (itemHref === currentPath) return true
  // Coincidencia por prefijo (para rutas anidadas)
  if (currentPath.startsWith(itemHref) && itemHref !== '/') return true
  return false
}
export default {
  topLevelItems,
  navigationGroups,
  getNavItemByPath,
  isNavItemActive,
}


